module.exports = "/_next/static/images/landing-hero-desktop-1ba5d67d9a64a35535cda38bd108d832.png.webp";